<template>
  <div class="container">
    <div class="vue">
      <div class="header  padHorizontal10">
        <div class="userinfo flex flexJc-fe flexAi-c">
          <!-- <span>无锡零忧托管理系统</span> -->
          <!-- <el-button class="share-button">
            <i class="el-icon-chat-line-round "> </i>
            <el-badge class=" absolute" :value="12"> </el-badge>
          </el-button> -->
          <el-button class="share-button" @click="chatBut">
            <i class="el-icon-message-solid"></i>
            <el-badge class="absolute" :value="unreadMesNum"> </el-badge>
          </el-button>
          <el-button @click="withdrawClick" icon="el-icon-switch-button">退出</el-button>
        </div>
        <div class="breadcrumb">
          <bread></bread>
        </div>
      </div>
      <div class="leftNav">
        <div class="logo flex">
          <el-image
            :src="require('@/assets/login_images/logoWhite.png')"
          ></el-image>
          <span>零忧托</span>
        </div>
        <el-menu
          style="border-bottom:0;"
          class="el-menu-demo"
          text-color="#fff"
          active-text-color="#fff"
          background-color="#545c64"
          router
          :default-active="$route.path"
        >
          <el-submenu
            v-for="(item, index) in items"
            :key="index"
            :index="item.url"
          >
            <template class="plate flex " slot="title">
              <el-image class="image" :src="item.img"></el-image>
              <span slot="title">{{ item.name }}</span>
            </template>
            <el-menu-item-group v-if="item.list != undefined">
              <el-menu-item
                v-for="(value, newIndex) in item.list"
                :key="newIndex"
                :index="value.url"
              >
                {{ value.name }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </div>
      <div class="rightCon">
        <div class="cotant">
          <router-view></router-view>
        </div>
      </div>
    </div>

    <el-drawer
      title="聊天消息"
      :size="drawerWidth"
      :visible.sync="drawer"
      :append-to-body="true"
      :before-close="handleClose">
      <div class="scroll-container">
        <div class="scroll-content">
          <!--订单信息-->
          <el-descriptions :contentStyle="ed_cs" :label-style="ed_ls" border class="margin-top" :column="2">
            <el-descriptions-item>
              <template slot="label"><i class="el-icon-user"></i>订单用户</template>
              {{ indent.name }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"><i class="el-icon-document-copy"></i>订单编号
              </template>
              <el-select v-model="indent.id" placeholder="请选择" filterable>
                <el-option v-for="item in indentOptions" @click.native="changeIndent(item.value)"
                  :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-button type="primary" @click="createChatRoomBut">建群</el-button>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"><i class="el-icon-mobile-phone"></i>手机号</template>
              {{ indent.tel }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"><i class="el-icon-tickets"></i>商品名</template>
              {{ indent.indentname }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"><i class="el-icon-date"></i>订单时间</template>
              {{ indent.dingdanshijian | filterTime}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"><i class="el-icon-money"></i>金额</template>
              {{ indent.indentprice }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"><i class="el-icon-position"></i>订单状态</template>
              {{ indent.payType | filterPayType }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"><i class="el-icon-office-building"></i>服务地址</template>
              {{ indent.address }}
            </el-descriptions-item>
          </el-descriptions>
          <!-- 聊天-->
          <mchat
              ref="mchat"
              :config="config"
              :chats="chats"
              :mine="mine"
              @removeChat="handleChatRemove"
              @talkUserClick="handleTalkUserClick"
              @talkClick="handleTalkClick"
              @chatInfo="handleChatInfo"
              @sendMessage="sendMessage"
              @loadHistory="handleHistory"
              @uploadEvent="handleUpload"
              @tabChat="handleTabClick">
              <mchat-right-box>
                  <template slot-scope="props">
                      <mchat-group-list
                          v-if="props.chat.type == 'group'"
                          :notices="props.chat.notices"
                          :userList="props.chat.userList"
                          :filter-user-method="filterUser"
                          @click="handleRightEvent">
                      </mchat-group-list>
                      <div v-else>非群组</div>
                  </template>
              </mchat-right-box>
          </mchat>
        </div>
      </div>

      <!-- 群选择 -->
      <el-dialog title="群员编辑" width="650px" :visible.sync="chatRoomDialogVisible"
        :modal="chatRoomModal" :modal-append-to-body="chatRoomModalATB">
        <el-transfer v-model="selectServer" :data="serverData" :titles="['服务人员', '已选择']"></el-transfer>
        <div slot="footer" class="dialog-footer">
          <el-button @click="chatRoomDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="chatRoomAddBut">确 定</el-button>
        </div>
      </el-dialog>

    </el-drawer>
	  <audio src="../assets/audio/tip.mp3" id="playAudio"></audio>
	  <audio src="../assets/audio/tip2.mp3" id="playTipAudio"></audio>
  </div>
</template>

<script>

import CONST from "./constant";
import Transfer from '@/utils/transfer'

import bread from '@/components/BreadCrumb/BreadCrumb'
import { apiSignOutAdmin } from '@/api/user'
import { apiChatSession, apiChatRoom, apiGetChatRoom, apiChatMessage, apiChatRoomOpen, apiChatSessionDisplay } from '@/api/chat'
import { apiUploadByBase64 } from '@/api/uploading'
import { apiGetJKServerList, apiGetIndentByUid, apiGetIndentById } from '@/api/orderManage'
import { apiGetMemberListByUid } from '@/api/clientManage'
export default {
  name: '',
  props: [''],
  data() {
    return {
      
      // 聊天
      unreadMesNum: 0,
      myMessage: [],
      drawerWidth: '800px',//'42%',
      drawer: false,
      config: {
          // 是否有下拉按钮
          downBtn: true,
          rightBox: true,
          // 简约模式
          brief: true,
          // 是否开启桌面消息提醒，即在浏览器之外的提醒
          notice: false,
          // 设定
          voice: true,
          //上传文件的扩展名
          fileExt:"",
          tabRemove:false,
          fixed:true,
      },
      //我的信息
      mine: CONST.mine,
      //会话
      chats: CONST.chats,
      uid: null,
      adRole: 0,
      lastMesIds: {},
      pageInfo: {page: 0, pageSize: 20},
      // 订单
      orderIn: false,// 从订单进
      userInfo: {},
      indent: {},
      indentList: [],
      indentOptions: [],
      // 群创建
      chatRoomDialogVisible: false,
      chatRoomModal: false,
      chatRoomModalATB: false,
      chatRoomId: null,
      selectUid: null,
      selectServer: [],
      serverData: [],


      // 侧边菜单
      items: [
        {
          name: '控制面板',
          url: '/1',
          img: require('@/assets/leftNav/kzmb.png'),
          list: [
            { name: '修改密码', url: '/revisePassword' },
            { name: '用户数量统计', url: '/statistics' },
            { name: '后台人员管理', url: '/ManagingPeople' },
            { name: '版本控制', url: '/version' }
          ]
        },
        {
          name: '预警管理',
          url: '/9',
          img: require('@/assets/leftNav/yjgl.png'),
          list: [
            { name: '大屏预警', url: '/alertScreen' },
            { name: '动态信息', url: '/alertPerson' },
            { name: '报警记录', url: '/alertMessage' }
          ]
        },
        {
          name: '人员管理',
          url: '/2',
          img: require('@/assets/leftNav/rygl.png'),
          list: [
            { name: '服务人员状态', url: '/personnelStatus' },
            { name: '登记服务人员', url: '/registerUser' },
            { name: '商务合作申请列表', url: '/businessCooperation' }
          ]
        },
        {
          name: '客户信息',
          url: '/3',
          img: require('@/assets/leftNav/kzmb.png'),
          list: [
            { name: '基本信息', url: '/BasicInfo' },
            { name: '在线预约', url: '/subscribe' },
            { name: '签到管理', url: '/SignInManage' },
            // { name: '客户档案', url: '/reportManage' },
            { name: '客户档案', url: '/reportSimpleManage' },
            { name: '今日管理', url: '/todayRecord' },
            { name: '健管方案', url: '/schemeManage' },
            { name: '疗愈生活', url: '/healingManage' },
            { name: '随访管理', url: '/accessManage' },
          ]
        },
        {
          name: '订单管理',
          url: '/4',
          img: require('@/assets/leftNav/ddgl.png'),
          list: [
            { name: '订单信息', url: '/orderInfo' },
            { name: '评价管理', url: '/evaluateManage' },
            { name: '提现记录', url: '/WithdrawalRecord' }
          ]
        },
        {
          name: '产品管理',
          img: require('@/assets/leftNav/cpgl.png'),
          url: '/5',
          list: [
            { name: '产品列表', url: '/ProductList' },
            { name: '商城产品列表', url: '/ShopList' }
          ]
        },
        {
          name: '文章管理',
          url: '/6',
          img: require('@/assets/leftNav/wzgl.png'),
          list: [
            { name: '文章栏目', url: '/column' },
            { name: '健康在线文章管理', url: '/healthArticle' },
            { name: '资讯文章管理', url: '/InfoArticle' },
            { name: '资质文章管理', url: '/certification' }
          ]
        },
        {
          name: '信息上传',
          url: '/7',
          img: require('@/assets/leftNav/xxsc.png'),
          list: [{ name: '图片管理', url: '/imgMessage' }]
        },
        {
          name: '智慧健身',
          img: require('@/assets/leftNav/zhjs.png'),
          url: '/8',
          list: [
            // { name: '会员列表', url: '/memberList' },
            // { name: '教练列表', url: '/coachesList' },
          ]
        }
      ],

      items_jkgj: [
      {
          name: '预警管理',
          url: '/9',
          img: require('@/assets/leftNav/yjgl.png'),
          list: [
            { name: '大屏预警', url: '/alertScreen' },
            { name: '动态信息', url: '/alertPerson' },
            { name: '报警记录', url: '/alertMessage' }
          ]
        },
        {
          name: '客户信息',
          url: '/3',
          img: require('@/assets/leftNav/kzmb.png'),
          list: [
            { name: '基本信息', url: '/BasicInfo' },
            { name: '在线预约', url: '/subscribe' },
            { name: '签到管理', url: '/SignInManage' },
            // { name: '客户档案', url: '/reportManage' },
            { name: '客户档案', url: '/reportSimpleManage' },
            { name: '今日管理', url: '/todayRecord' },
            { name: '健管方案', url: '/schemeManage' },
            { name: '疗愈生活', url: '/healingManage' },
            { name: '随访管理', url: '/accessManage' },
          ]
        },
        {
          name: '订单管理',
          url: '/4',
          img: require('@/assets/leftNav/ddgl.png'),
          list: [
            { name: '订单信息', url: '/orderInfo' },
            { name: '评价管理', url: '/evaluateManage' },
            { name: '提现记录', url: '/WithdrawalRecord' }
          ]
        },
      ],
      
      // 抽屉表单css
      ed_cs :{
        'text-align': 'left',  //文本居中
        'min-width': '180px',   //最小宽度
        'word-break': 'break-all'  //过长时自动换行;
      },
      ed_ls :{
        'color': '#000',
        'text-align': 'left',
        'font-weight': '500',
        'height': '30px',
        'background-color': '#C8C6C6',
        'min-width': '150px',
        'word-break': 'keep-all'
      },

    }
  },

  components: {
    bread
  },

  computed: {},

  beforeMount() {},

  mounted() {
    this.uid = localStorage.getItem("uid");
    this.adRole = localStorage.getItem("myAdRole");
    if(this.adRole == 1) {
      this.items = this.items_jkgj;
    }

    this.getMineInfo();// 个人信息初始化
    this.getChatSessions();// 获取聊天会话

    this.initWebSocket();
    Transfer.$on('chat-open', val=>{
      this.orderIn = true;
      this.indent.id = val.id;
      this.chatBut(val);
    })
    this.mesWebSocket();
  },

	created() {
		// 设定一些监听的事件
		let that = this;
		window.addEventListener("acceptScreenMessage", function(e) {
			that.$notify({title: '报警提醒', message: "收到报警,请立即处理！", position: 'bottom-right', duration: 0});
      let playAudio = document.getElementById('playAudio');
			playAudio.play();
		});
		window.addEventListener("acceptTodayMessage", function(e) {
			let message = JSON.parse(e.data);
			let content = message.content;
      that.$notify({title: '今日提醒', message: content, position: 'bottom-right', duration: 0});
			let playTipAudio = document.getElementById('playTipAudio');
			playTipAudio.play();
		});
		// 正常上传记录
		window.addEventListener("acceptUploadMessage", function(e) {
			let message = JSON.parse(e.data);
			let content = message.content;
      that.$notify({title: '体检提醒', message: content, position: 'bottom-right', duration: 0});
      let playTipAudio = document.getElementById('playTipAudio');
			playTipAudio.play();
		});
	},
  methods: {
    // 退出登录
    withdrawClick() {
      this.$confirm('此操作将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          apiSignOutAdmin().then(res => {
            if (res.status === 10) {
              this.$Me(res.msg)
              localStorage.removeItem('Token') // 移除所有的缓存数据
              this.closeWebSocket();
              setTimeout(() => {
                this.$router.push('/')
              }, 1000)
            } else if (res.status === 1) {
              this.$Me(res.msg)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
    changeIndent(indentId) {// 选择订单
      this.indent.id = indentId;
      this.indentList.forEach( i => {
        if(i.id == indentId) {
          this.indent.tel = i.tel;
          this.indent.indentname = i.indentname;
          this.indent.dingdanshijian = i.dingdanshijian;
          this.indent.indentprice = i.indentprice;
          this.indent.payType = i.payType;
          this.$forceUpdate();// 强制刷新数据
          return;
        }
      });
    },
    createChatRoomBut() {// 创建群会话
      if(this.indent == null || this.indent.id == null || this.indent.id == undefined || this.indent.id == "") {
        this.$message({type: 'error', message: '请先选择订单'});
        return;
      }
      this.chatRoomId = null;
      this.serverData = [];
      this.selectServer = [];
      apiGetJKServerList({
      }).then(res => {
        if (res.status === 0) {
          let serverAll = [];
          res.data.forEach( d => {
            this.serverData.push({
              key: "wx-" + d.id,
              label: d.servername
            });
            serverAll.push("wx-" +d.id);
          });

          apiChatRoom({
            indentId: this.indent.id,
          }).then(res => {
            if (res.status === 0) {
              let data = res.data;
              if(data != null) {
                this.chatRoomId = data.id;
                data.csList.forEach( cs => {
                  if(serverAll.includes(cs.fromid)) {
                    this.selectServer.push(cs.fromid);
                  }
                });
                console.log("selectServer", this.selectServer);
              }
            }
          });
          this.chatRoomDialogVisible = true;
        }
      });
    },
    chatRoomAddBut() {// 群保存
      // console.log('xxx:',this.selectServer)
      // if(1==1)return;
      let ssids = this.selectServer.join(",");
      let chatRoom = {
        id: this.chatRoomId,
        name: this.indent.name + "-" + this.indent.indentname,
        uid: this.selectUid,
        mid: this.uid,
        indentId: this.indent.id,
        ids: ssids,
      };
      apiChatRoomOpen(chatRoom).then(res => {
        if(res.status == 0) {
          this.$message({message: '保存成功', type: 'success'});
          this.chatRoomDialogVisible = false;
        }
      });
    },
    getIndentList(cid) {// 获取人员信息和订单列表
      if(cid == null || cid == undefined || cid == "") {
        return;
      }
      let payTypes = "100,200,800,1200,1300";
      // 人员信息
      apiGetMemberListByUid({
        uids: cid,
      }).then(res => {
        if (res.status === 0) {
          let ms = res.data;
          if(ms.length > 0) {
            ms.forEach(m => {
              if(m.relation == '本人') {
                this.indent.name = m.name;
                this.indent.address = m.address;
              }
            });
            if(this.indent.name == null || this.indent.name == "") {
              this.indent.name = ms[0].name;
              this.indent.address = ms[0].address;
            }
          }
        }
      });
      // 订单列表
      apiGetIndentByUid({
        cid: cid,
        payTypes: payTypes
      }).then(res => {
        if (res.status === 0) {
          this.indentList = res.data;
          this.indentOptions = [];
          this.indentList.forEach( d => {
            this.indentOptions.push({label: d.outTradeNo, value: d.id});
          });
          if(this.indentOptions.length > 0) {
            if(this.orderIn) {
              this.changeIndent(this.indent.id);
              this.orderIn = false;
            } else {
              this.indent.id = this.indentOptions[0].value;
              this.changeIndent(this.indent.id);
            }
          }
        }
      });
    },
    getIndentOne(roomId) {// 获取人员信息和指定订单
      if(roomId == null || roomId == undefined || roomId == "") {
        return;
      }
      let _this = this;
      apiGetChatRoom({
        id: roomId
      }).then(rd => {
        if(rd.status === 0) {
          let cid = rd.data.uid.split('-')[1];
          let indentId = rd.data.indentId;
          // 人员信息
          apiGetMemberListByUid({
            uids: cid,
          }).then(res => {
            if (res.status === 0) {
              let ms = res.data;
              if(ms.length > 0) {
                ms.forEach(m => {
                  if(m.relation == '本人') {
                    _this.indent.name = m.name;
                    _this.indent.address = m.address;
                  }
                });
                if(_this.indent.name == null || _this.indent.name == "") {
                  _this.indent.name = ms[0].name;
                  _this.indent.address = ms[0].address;
                }
              }
            }
          });
          // 指定订单
          apiGetIndentById({
            id: indentId
          }).then(res => {
            if (res.status === 0) {
              this.indentList = res.data;
              this.indentOptions = [];
              this.indentList.forEach( d => {
                this.indentOptions.push({label: d.outTradeNo, value: d.id});
              });
              if(this.indentOptions.length > 0) {
                if(this.orderIn) {
                  this.changeIndent(this.indent.id);
                  this.orderIn = false;
                } else {
                  this.indent.id = this.indentOptions[0].value;
                  this.changeIndent(this.indent.id);
                }
              }
            }
          });
        }
      });
    },
    chatSeesionIn(toid) {// 进入会话
      if(toid == null || toid == undefined || toid == "") {
        return;
      }
      let that = this;
      setTimeout(function(){
        let openMessage = {fromid: this.uid, toid: toid, type: 'open'};
        that.$websocket.wsSendMessage(openMessage);// 标记已读
        // chats未读数据修改
        that.chats.forEach(chat => {
          if(chat.id == toid) {
            chat.unread = 0;
          }
        });
        that.calUnreadMesNum();
        // 获取历史数据
        // that.$emit("loadHistory");
      }, 500)
    },
    // 客户感兴趣提示
    serviceAccess() {
      let tips = "xxx查看了" + "服务，是否接入?" ;
      this.$confirm(tips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消接入'
        });          
      });
    },
    


    // 聊天
    async initWebSocket() {
      this.$websocket.connectWebsocket();
    },
    async closeWebSocket() {
      this.$websocket.closeWebSocket();
    },
    async mesWebSocket(){
      let that = this;
      window.addEventListener("sendNewMessage", e => {
        let detail = e.detail;
        if(detail.submit == 1) {
          // 发送成功
        } else {
          // 发送失败
          that.$message.error('发送失败,请刷新页面');
        }
      });
    },
    chatBut(row){
      this.drawer = true;
      this.getChatSessions();// 获取聊天会话
    },
    filterUser(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
    },
    handleClose() {
      this.drawer = false;
    },
    handleChatRemove({ id, name, type }){
        // console.log("事件名：removeChat。点击对话标签删除或择对话框关闭触发");
        // 本地移除
        let channels = this.chats;
        let len = channels.length;
        if (len < 1) return;
        let ary = [];
        for (let i = 0; i < len; i++) {
            let model = channels[i];
            if (model.id !== id) {
                ary.push(model);
            }
        }
        this.chats = ary;
        // 后端移除
        apiChatSessionDisplay({fromid: this.uid, toid: id, type: type, display: 1}).then(res => {});
    },
    handleRightEvent(event) {
        console.log("右边框事件", event);
    },
    handleHistory(data) {
        const {chat ,last, callback} = data;
        let that = this;

        let idStr = chat.id + "";
        let lastMesId = this.lastMesIds[idStr];
        apiChatMessage({id: lastMesId, fromid: this.uid, toid: chat.id, 
          page: 1, pageSize: this.pageInfo.pageSize, messageType: chat.type}).then(res => {
          if (res.status === 0) {
            let history = res.data.list;
            history.forEach(h => {
              if(h.fromid == that.uid) {
                h.mine = true;
                h.avatar = require("@/assets/leftNav/service.png");
              } else {
                h.mine = false;
                h.avatar = require("@/assets/leftNav/patient.png");
              }
            });
            // 获取查询起始id
            if(history.length > 0) {
              lastMesId = history[history.length-1].id;
              this.lastMesIds[idStr] = lastMesId;
            }
            callback(history);
          }
        })
    },
    sendMessage(data) {
      let requestId = this.$websocket.wxuuid();
      const {mine, to, content, timestamp} = data;
      this.myMessage = {
          //消息的发送者id（比如群组中的某个消息发送者），可用于自动解决浏览器多窗口时的一些问题
          fromid: mine.id,
          //消息的来源ID（如果是私聊，则是用户id，如果是群聊，则是群组id）
          toid: to.id,
          //聊天窗口来源类型，从发送消息传递的to里面获取
          type: to.type,
          //消息来源用户名
          username: mine.username,
          //消息来源用户头像
          avatar: mine.avatar,
          //消息内容
          content,
          // 发送内容格式 0文本 1图片 2音频
          format: 0,
          //消息id，可不传。除非你要对消息进行一些操作（如撤回）
          cid: 0,
          //是否我发送的消息，如果为true，则会显示在右方
          mine: true,
          //服务端时间戳毫秒数。注意：如果你返回的是标准的 unix 时间戳，记得要 *1000
          //timestamp,
          requestId: requestId
      };
      // 发送
      this.$websocket.wsSendMessage(this.myMessage);
      this.$refs.mchat.getMessage(this.myMessage);
      // this.chatList();
      // //自动回复
      // let authReplay = {
      //     username: "july-meteor",
      //     avatar:require("@/assets/login_images/newlogo.png"),
      //     id: to.id,
      //     type: to.type,
      //     content:  replay[(Math.random() * 9) | 0],
      //     cid: 0,
      //     mine: false,
      //     fromid: -1,
      //     timestamp: new Date(),
      // };
      // this.$im.emit("getMessage", authReplay);
    },
    handleUpload(data,fn){
      let that = this;
      const {file ,type, mes} = data;
      if(type !== 'img'){
        this.$message({message: '文件格式错误', type: 'error'});
        return;
      }
      const reader = new FileReader()
      reader.readAsDataURL(file) // 开始转
      reader.onload = function(e) {
        let imageStr = this.result.split('base64,')[1];
        apiUploadByBase64({
          base64: imageStr,
          path: 'ChatReport'
        }).then(res => {
          if (res.status === 0) {
            let imgUrl = that.baseImage + res.data;
            let content = `img[${imgUrl}]`;
            let requestId = that.$websocket.wxuuid();
            that.myMessage = {
                fromid: mes.mine.id,
                toid: mes.to.id,
                type: mes.to.type,
                username: mes.mine.username,
                avatar: mes.mine.avatar,
                content,
                format: 1,
                cid: 0,
                mine: true,
                requestId: requestId
            };
            console.log('myMessage', that.myMessage);
            that.$websocket.wsSendMessage(that.myMessage);
            that.$refs.mchat.getMessage(that.myMessage);
          }
        })
      }
    },
    handleTalkUserClick(item){
        console.log("事件名：talkUserClick。对话用户头像点击事件",item);
    },
    handleTalkClick(item){
        console.log("事件名：talkClick。对话内容点击事件",item);
    },
    handleChatInfo(item){
        console.log("事件名：chatInfo。点击窗口对话头像触发",item);
    },
    handleTabClick(pane){
      // 切换会话
      this.indent = {};
      let schat = pane.chat;
      if(schat.type == "group") {
        let rid = schat.id;
        let roomId = rid.split('-')[1];
        this.getIndentOne(roomId);
        this.chatSeesionIn(rid);
        this.selectUid = rid;
      } else {
        let uid = schat.id;
        let cid = uid.split('-')[1];
        this.getIndentList(cid);
        this.chatSeesionIn(uid);
        this.selectUid = uid;
      }
    },

    getMineInfo() {
      let adUname = localStorage.getItem("adUname");
      this.mine = {
        id: this.uid,
        username: adUname,
        status: "online",
        sign: "为您服务",
        avatar: require("@/assets/leftNav/service.png"),
      };
    },
    getChatSessions() {
      let uid = localStorage.getItem('uid');
      apiChatSession({fromid: uid, display: 0}).then(res => {
        if (res.status === 0) {
          let tempChats = [];
          res.data.forEach(c => {
            let avatarPath = require("@/assets/leftNav/default_avatar.png");
            if(c.type == "group") {
              avatarPath = require("@/assets/leftNav/group_avatar.png");
            }
            tempChats.push({
              id: c.toid,
              name: c.toname,
              type: c.type,
              unread: c.unread,
              online: c.online,
              avatar: avatarPath,
            });
          });
          this.chats = tempChats;
          // 取第一个
          if(this.chats.length > 0) {
            let defaultChat = this.chats[0];
            if(defaultChat.type == 'group') {
              let rid = defaultChat.id;
              let roomId = rid.split('-')[1];
              this.getIndentOne(roomId);
              this.chatSeesionIn(rid);
              this.selectUid = rid;
            } else {
              let cid = defaultChat.id.split('-')[1];
              this.getIndentList(cid);
              this.chatSeesionIn(defaultChat.id);
              this.selectUid = defaultChat.id;
            }
          }
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
    },
    // 计算提示的数量
    calUnreadMesNum() {
      this.unreadMesNum = 0;
      this.chats.forEach(chat => {
        this.unreadMesNum = this.unreadMesNum + chat.unread;
      });
    },

  },

  watch: {}
}
</script>
<style lang="scss" scoped>
$padding: 10px;
.vue {
  .header {
    height: 60px;
    position: fixed;
    top: 0;
    left: 12%;
    right: 0;
    line-height: 60px;
    background: #fff;
    border-bottom: 1px solid #d9d9d9;
    .userinfo {
      height: 60px;

      /deep/ i {
        color: red;
        font-size: 18px;
      }
      .share-button {
        padding: 12px 30px;
        .el-badge {
          margin-top: -10px;
          margin-left: -10px;
        }
      }
    }
  }
  .leftNav {
    width: 12%;
    position: absolute;
    .logo {
      justify-content: center;
      align-items: center;
      padding: $padding;
      background-color: #119685;
      height: 5vh;
      .el-image {
        width: 26px;
        height: 26px;
      }
      span {
        font-size: 1.275em;
        padding-left: $padding;
        color: #fff;
        font-weight: bolder;
      }
    }
    .el-menu {
      width: 100%;
      height: 95vh;
      .el-submenu {
        .el-menu-item {
          min-width: 0;
        }
        .el-submenu__title {
          justify-items: center;
          align-items: center;
          .el-image {
            width: 30px;
            height: 30px;
          }
          span {
            padding-left: 4px;
          }
        }
      }
    }
    .el-menu-item.is-active {
      background-color: #119684a8 !important;
    }
  }
}
.rightCon {
  position: fixed;
  top: 110px;
  left: 12%;
  right: 0;
  bottom: 0;
  overflow: auto;
  background-color: #e5e6ee;
  transition: all 0.2s;
  .header {
    height: 6%;
    color: #59607b;
    align-items: center;
    padding: $padding;
    border-bottom: 1px solid #d9d9d9;
    .left {
      align-items: center;
      .el-image {
        width: 2em;
        height: 2em;
      }
      span {
        padding-left: $padding;
      }
    }
  }
  .breadcrumb {
    height: 50px;
    background-color: #fff;
  }
  .cotant {
    padding: $padding;
    background-color: #e5e6ee;
  }
}
.scroll-container {
  height: 900px; /* 设置固定高度 */
  overflow-y: auto; /* 开启垂直滚动条 */
}
.scroll-content {
  height: 900px; /* 假设内容高度足够多 */
}
</style>
